import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Report } from '../models/report';
import { Observable } from 'rxjs';
import { AreaFormComponent } from '../area-form/area-form.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AreaItemFormComponent } from '../area-item-form/area-item-form.component';
import { ReportService } from '../services/report.service';
import { AreaService } from '../services/area.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-report-detail',
    templateUrl: './report-detail.component.html',
    styleUrls: ['./report-detail.component.css'],
    standalone: false
})
export class ReportDetailComponent implements OnInit {

  report: Report;
  //reportDoc: AngularFirestoreDocument<Report>;
  //report$: Observable<Report>;
  listOfAreas$: Observable<any[]>
  reportId: string = '';
  sectionId: string = '';
  studentId: string = '';


  constructor(
    private route: ActivatedRoute,
    private reportService: ReportService,
    private areaService: AreaService,
    private matSnackBar: MatSnackBar,
    private matDialog: MatDialog) { }

  async ngOnInit() {

    await this.getDetails();
  }

  async getDetails() {

    this.route.paramMap.subscribe(async p => {

      this.reportId = p.get('repId');
      this.sectionId = p.get('secId');
      this.studentId = p.get('studentId');

      this.report = await this.reportService.readByIdAsync(this.sectionId, this.reportId);
      this.listOfAreas$ = this.areaService.readObservablesByReportId(this.sectionId, this.reportId);

      // this.reportDoc = this.db.doc<Report>('sections/' +  this.sectionId + '/templates/' + this.reportId);
      // this.report$ = this.reportDoc.valueChanges(); //this is an observer, the variable report$ is waiting.

      // this.listOfAreas$ = this.reportDoc.collection<Area>('areas', ref => {
      //   return ref.orderBy("date", "asc")
      // })
      // .snapshotChanges()
      // .pipe(
      //   map(actions => {
      //     return actions.map(a => {
      //         const data = a.payload.doc.data() as Report
      //         const id = a.payload.doc.id;
      //         return { id, data }
      //     })
      //   })
      // )


      // this.db.doc<Comment>('comments/' + this.sectionId + '-' + this.reportId  + '-' + this.studentId)
      // .valueChanges()
      // .subscribe(a => {
      //   this.comment = a as Comment
      // });

    })
  }

  newArea() {
    let dialogRef = this.matDialog.open(AreaFormComponent, {
      width: '600px',
      data: { reportId: this.reportId, areaId: '', sectionId: this.sectionId }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result) {
           this.matSnackBar.open('Se creó con éxito', "Close", {
            verticalPosition: "bottom",
            duration: 3000,
          });
      }
      console.log("after closed event");
    });
  }

  updateArea(areaId) {
    let dialogRef = this.matDialog.open(AreaFormComponent, {
      width: '600px',
      data: { reportId: this.reportId, areaId: areaId, sectionId: this.sectionId }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("after closed event");

      if (result) {
          this.matSnackBar.open('Se actualizó con éxito', "Close", {
            verticalPosition: "bottom",
            duration: 3000,
          });
      }
    });
  }

  async deleteArea(areaId) {
    if (confirm('¿Está seguro de eliminar el área y todos sus items?'))
    {
      await this.areaService.deleteAsync(this.sectionId, this.reportId, areaId);

       this.matSnackBar.open('Se eliminó con éxito', "Close", {
            verticalPosition: "bottom",
            duration: 3000,
          });

      //Versión anterior
      // this.db.doc<Area>('sections/' + this.sectionId + '/templates/' + this.reportId + '/areas/' + areaId)
      // .delete()
      // .then(a => {
      //   alert('El área se eliminó con éxito');
      // })
    }
  }

  newItem(areaId)
  {
    console.log(areaId);
    let dialogRef = this.matDialog.open(AreaItemFormComponent, {
      width: '600px',
      data: { reportId: this.reportId, areaId: areaId, sectionId: this.sectionId, areaItemId: '' }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("after closed event");

      if (result) {
        this.matSnackBar.open('El ítem se creó con éxito', "Close", {
            verticalPosition: "bottom",
            duration: 3000,
          });
      }
    });
  }



}
